import { combineReducers } from "redux";
import authenticationReducer from "./authenticationReducer";
import mailReducer from "./mailReducer";
import notificationsReducer from "./notificationsReducer";
import settingsReducer from "./settingsReducer";

const rootReducer = combineReducers({
  authentication: authenticationReducer,
  mail: mailReducer,
  notifications: notificationsReducer,
  settings: settingsReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.ts